import CrmProductsAPI from 'dashboard/api/crmProducts';

const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

const getters = {
  getProducts: $state => $state.records,
  getActiveProducts: $state => $state.records.filter(p => p.active),
  getUIFlags: $state => $state.uiFlags,
  getProductById: $state => id => $state.records.find(p => p.id === id),
};

const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await CrmProductsAPI.get(params);
      commit('SET_PRODUCTS', data.payload);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async create({ commit }, productData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await CrmProductsAPI.create(productData);
      commit('ADD_PRODUCT', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, ...productData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await CrmProductsAPI.update(id, productData);
      commit('UPDATE_PRODUCT', data.payload);
      return data.payload;
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await CrmProductsAPI.delete(id);
      commit('DELETE_PRODUCT', id);
    } catch (error) {
      throw error;
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },
};

const mutations = {
  SET_UI_FLAG($state, flag) {
    $state.uiFlags = { ...$state.uiFlags, ...flag };
  },
  SET_PRODUCTS($state, products) {
    $state.records = products;
  },
  ADD_PRODUCT($state, product) {
    $state.records.push(product);
  },
  UPDATE_PRODUCT($state, product) {
    const index = $state.records.findIndex(p => p.id === product.id);
    if (index !== -1) {
      $state.records.splice(index, 1, product);
    }
  },
  DELETE_PRODUCT($state, id) {
    $state.records = $state.records.filter(p => p.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
